module.exports = __webpack_public_path__ + "img/cluster-icon.7f2e4554.svg";